import { render, staticRenderFns } from "./PrintVotingPaperBig.vue?vue&type=template&id=44e3fbbd&scoped=true"
import script from "./PrintVotingPaperBig.vue?vue&type=script&lang=js"
export * from "./PrintVotingPaperBig.vue?vue&type=script&lang=js"
import style0 from "./PrintVotingPaperBig.vue?vue&type=style&index=0&id=44e3fbbd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e3fbbd",
  null
  
)

export default component.exports